<template>
    <div v-if="component_done_loading" > <!-- v-shortkey.propagte="{left:['arrowleft'],right:['arrowright']}" @shortkey="paginationAccessibility" -->
        <template v-for="(question,idx) in testObj.questions[current_question_group_idx]">
            <question @submitAnswer="submitAnswer" :testObj="testObj" :question="question" :question_group_idx="current_question_group_idx" :question_idx="idx" @change-question="changeQuestion" :tempAnswers="tempAnswers" :typing="typing" :sharedObj="sharedObj"></question>
        </template>
    </div>
</template>
<script>
import {testMixins} from './../../../../../../mixins/test';
export default {
	props:['testObj','fetchTest'],
    mixins:[testMixins],
	components: {
        'question': require(`./question/question.vue`).default,
    },
    mounted(){
    	var that = this;
        this.init();
    	Events.listen('test-restarted',function(){
            that.component_done_loading = false;
            Vue.nextTick(function(){
                that.init();
                that.component_done_loading = true;
            })
        });
        Events.listen('change-question',function(to){
            let bool = true;
            if((that.testObj.type=='trat'||(that.testObj.type=='application'&&that.testObj.others.applicationType=='team'))&&!that.isTeamLeader){
                bool = false;
            }
            if((that.testObj.type=='trat'||(that.testObj.type=='application'&&that.testObj.others.applicationType=='team'))&&that.isTestCompleted){
                bool = false
            }
            that.changeQuestion(to,bool);
        })
        this.component_done_loading = true;
    },
    data(){
        var that = this;
    	return {
            component_done_loading:false,
            tempAnswers:[],
            typing:false,
            sharedObj:{isFormBusy:false}
    	}
    },
    methods:{
        paginationAccessibility(event){
            var that = this;
            if(($("#test_confirm_modal").data('bs.modal') || {}).isShown){
                return;
            }
            switch(event.srcKey){
                case 'left':
                    if(that.canChangeQuestion(that.previous_question_group_idx,that.previous_question_idx)){
                        that.moveToDifferentQuestion(that.previous_question_group_idx,that.previous_question_idx)
                    }    
                break
                case 'right':
                    if(that.canChangeQuestion(that.next_question_group_idx,that.next_question_group_idx)){
                        that.moveToDifferentQuestion(that.next_question_group_idx,that.next_question_idx)
                    }
                break;
            }
        },
        init(){
            var that = this;
            let currentQuestionUuid = _.get(this.testObj,'myProgression.currentQuestionUuid',false);
            if(currentQuestionUuid==null){
                this.changeQuestion({question_group_idx:0,question_idx:0},false);
            }
            for(var i = 0; i <this.testObj.questions.length;i++){
                this.tempAnswers.push([]);
                for(var j = 0; j<this.testObj.questions[i].length;j++){
                    let question = this.testObj.questions[i][j];
                    //get current saved question position
                    if(currentQuestionUuid){
                        if(question.uuid==currentQuestionUuid){
                            var q_group_idx = i;
                            var q_idx = j;
                            Vue.nextTick(function(){
                                that.changeQuestion({question_group_idx:q_group_idx,question_idx:q_idx},false);
                            });
                            
                        }
                    }
                    if(_.isEmpty(question.studentAnswer)){
                        Vue.set(question,'studentAnswer', {attempts:[],clarifications:'',comments:'',attachments:[]});
                    }
                    let storedAnswer = _.get(question,'studentAnswer.attempts',[]);
                    if(storedAnswer.length==0){
                        if(this.testObj.settings.confidenceBasedTesting&&['mcqs'].includes(question.type)){
                            //irat confidence based testing
                            this.tempAnswers[i][j] = {};
                            for(var k = 0;k<question.options.length;k++){
                                this.tempAnswers[i][j][question.options[k].key] = 0;
                            }
                        }
                        else if(['mcqs','openended'].includes(question.type)){
                            this.tempAnswers[i][j] = '';
                        }
                        else if(this.testObj.questions[i][j].type=='mcqm'){
                            this.tempAnswers[i][j] = [];
                        }
                    }else{
                        this.tempAnswers[i][j] = _.cloneDeep(storedAnswer[storedAnswer.length-1]);
                    }
                    if(!_.isArray(question.studentAnswer.attachments)){
                        question.studentAnswer.attachments = [];
                    }
                    //initialize
                    Vue.set(question.studentAnswer,'_clarifications', _.get(question,'studentAnswer.clarifications',''));
                    Vue.set(question.studentAnswer,'_comments', _.get(question,'studentAnswer.comments',''));
                    Vue.set(question.studentAnswer,'_attachments', _.clone(_.get(question,'studentAnswer.attachments',[])));
                    //randomize question order
                    if(this.testObj.type=='irat'){
                        if(this.testObj.settings.randomizeAnswerOptionOrder){
                            let len = question.options.length;
                            let retainLastOptionSequence = _.get(question.options,(len-1)+'.retainLastOptionSequence',false);
                            let lastOption = {};
                            if(retainLastOptionSequence){
                                lastOption = question.options.pop();
                            }
                            question.options = _.cloneDeep(_.shuffle(question.options));
                            if(retainLastOptionSequence){
                                question.options.push(lastOption);
                            }
                            for(var z = 0; z<question.options.length;z++){
                                if(!question.options[z].originalKey){
                                    question.options[z].originalKey = _.cloneDeep(question.options[z].key);
                                }
                                question.options[z].key = String.fromCharCode(65+z);
                            }

                            let curr_ans = false;
                            if(!this.testObj.settings.confidenceBasedTesting){
                                curr_ans = _.find(question.options,function(o){
                                    return o.originalKey==that.tempAnswers[i][j];
                                });
                                if(curr_ans){
                                    this.tempAnswers[i][j] = curr_ans.key;
                                }
                            }else{
                                let cloneTempAnswers = _.cloneDeep(this.tempAnswers[i][j]);
                                //console.log(cloneTempAnswers);

                                for(var z = 0; z<question.options.length;z++){
                                    this.tempAnswers[i][j][question.options[z].key] = cloneTempAnswers[question.options[z].originalKey];
                                }
                                 //console.log(this.tempAnswers[i][j]);
                            }
                            
                        }
                    }
                }
            }
        },
    	changeQuestion(to,sendToAPI=true){
    		this.current_question_group_idx=to.question_group_idx;
    		this.current_question_idx = to.question_idx;
    		Events.fire('current-question-changed',{question_group_idx:to.question_group_idx,question_idx:to.question_idx});
            if(sendToAPI&&!this.isPreview){
                if(this.testObj.type=='irat'){
                    this.testObj.myProgression.currentQuestionUuid = this.testObj.questions[this.current_question_group_idx][this.current_question_idx].uuid;
                }   
                axios.put('student/tests/'+this.testObj.uuid+'/update/current-question',{currentQuestionUuid:this.testObj.questions[this.current_question_group_idx][this.current_question_idx].uuid}).then(function(response){
                })
            }
	    },
        /*question_group_idx, question_idx, question*/
        submitAnswer(data){
            var that = this;
            var question_group_idx = data.question_group_idx;
            var question_idx = data.question_idx;
            let question = this.testObj.questions[question_group_idx][question_idx];
            let isCorrect = false;
            if (
                this.testObj.type == "trat" ||
                (this.testObj.type == "irat" && this.testObj.settings.immediateFeedback)
            ) {
                let answered = _.find(question.options, function(o) {
                return (
                    o.key ==
                    that.tempAnswers[question_group_idx][question_idx]
                );
                });
                isCorrect = _.get(answered, "isCorrect", false);
            }
            let answer = _.cloneDeep(
                this.tempAnswers[question_group_idx][question_idx]
            );
            //if options are randomized
            if (this.testObj.type == "irat") {
                if (this.testObj.settings.randomizeAnswerOptionOrder) {
                if (!this.testObj.settings.confidenceBasedTesting) {
                    answer = _.find(question.options, function(o) {
                    return o.key == answer;
                    });
                    answer = answer.originalKey;
                } else {
                    for (var z = 0; z < question.options.length; z++) {
                    answer[question.options[z].originalKey] = this.tempAnswers[
                        question_group_idx
                    ][question_idx][question.options[z].key];
                    }
                    //console.log(answer);
                }
                }
            }
            if (this.isTeacherPreview) {
                question.studentAnswer.attempts.push(answer);
                if (
                (that.testObj.type == "irat" &&
                    !_.get(that.testObj, "settings.immediateFeedback", false)) ||
                that.testObj.type == "application"
                ) {
                that.moveToDifferentQuestion(
                    that.next_question_group_idx,
                    that.next_question_idx
                );
                }
                if (
                that.testObj.type == "trat" ||
                (that.testObj.type == "irat" &&
                    _.get(that.testObj, "settings.immediateFeedback", false))
                ) {
                let correctKey = _.find(question.options, function(o) {
                    return o.isCorrect;
                });
                let k = correctKey.key;
                if (
                    this.testObj.type == "irat" &&
                    this.testObj.settings.randomizeAnswerOptionOrder
                ) {
                    k = correctKey.originalKey;
                }
                if (_.isEqual(k, answer)) {
                    question.studentAnswer.isCorrect = true;
                    question.hintOrExplanation = question.explanation;
                } else {
                    question.hintOrExplanation = question.hint;
                }
                if (question.type == "mcqs") {
                    Vue.set(
                    that.tempAnswers[question_group_idx],
                    question_idx,
                    ""
                    );
                }
                if (that.question.type == "mcqm") {
                    Vue.set(
                    that.tempAnswers[question_group_idx],
                    question_idx,
                    []
                    );
                }
            }
            return;
        }
        if (this.sharedObj.isFormBusy) {
            return;
        }
        this.sharedObj.isFormBusy = true;
        //var instance = axios.create({baseURL:''});
        //instance.post(process.env.VUE_APP_LOG_URL,{cluster:process.env.VUE_APP_APP_ENV,label:'saveMyAnswer',data:{userUuid:this.auth.user().uuid,testUuid:this.testObj.testUuid,userPlacementTestUuid:this.testObj.uuid,questionUuid:this.question.uuid,answer:answer}});
        axios
            .post(`/student/tests/${this.testObj.uuid}`, {
                activityQuestionUuid: question.uuid,
                answer: answer,
            })
            .then(function(response) {
            if(response.data.activityQuestionUuid!==question.uuid && response.data.activityQuestionUuid){
                return
            }
            question.studentAnswer.attempts.push(answer);
            question.studentAnswer.attempts2 = response.data.attempts;
            //Events.fire('changed-test',response.data.data);
            if (
                (that.testObj.type == "irat" &&
                !_.get(that.testObj, "settings.immediateFeedback", false)) ||
                that.testObj.type == "application"
            ) {
                that.moveToDifferentQuestion(
                that.next_question_group_idx,
                that.next_question_idx
                );
            }
            if (
                that.testObj.type == "trat" ||
                (that.testObj.type == "irat" &&
                _.get(that.testObj, "settings.immediateFeedback", false))
            ) {
                question.studentAnswer.attempts.push(answer);
                question.studentAnswer.isCorrect = response.data.isCorrect;
                question.hintOrExplanation = response.data.hintOrExplanation;
                if (question.type == "mcqs") {
                Vue.set(that.tempAnswers[question_group_idx], question_idx, "");
                }
                if (question.type == "mcqm") {
                Vue.set(that.tempAnswers[question_group_idx], question_idx, []);
                }
            }
            that.sharedObj.isFormBusy = false;
            })
            .catch(function(errors) {
                that.sharedObj.isFormBusy = false;
            });
        },
    }
    ,beforeDestroy(){
        Events.off('test-restarted',this.init);
        Events.off('change-question');
    }
}
</script>

<style>
	body.test .panel {
		height: 500px;
		border-radius: 3px;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
		background-color: #ffffff;
		border:1px solid #ededed;
	}

	body.test .panel-heading {
		background-image: linear-gradient(to bottom, #ffffff, #eff2f6);
		padding:15px 20px;
		font-size: 16px;
  		font-weight: bold;
  		text-transform: uppercase;
  		line-height:1;
  		border-bottom:1px solid #d8d8d8;
  		box-shadow: 0 2px 4px 0 rgba(202, 202, 202, 0.5);
	}

	body.test .panel-body {
		overflow: hidden;
    	overflow-y: auto;
    	white-space: pre-line;
    	padding:15px 20px;
        overflow: auto;
	}

	body.test .panel-footer {
		padding:20px;
		border-top:1px solid #d8d8d8;
		box-shadow: 0 -2px 4px 0 rgba(168, 168, 168, 0.5);	
		background:#fff;
	}

</style>